import React from 'react';
import { Link } from 'react-router-dom';
import { useCognitoAuth } from '../contexts/CognitoAuthContext';

const CognitoHeader: React.FC = () => {
  const { user, logout, isAuthenticated, isAdmin } = useCognitoAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">
            <h1>SyncMySquad</h1>
          </Link>
        </div>
        
        {isAuthenticated && user && (
          <div className="header-nav">
            <nav className="nav-menu">
              <Link to="/dashboard" className="nav-link">Dashboard</Link>
              {isAdmin && (
                <Link to="/admin" className="nav-link admin-link">Admin Panel</Link>
              )}
            </nav>
            
            <div className="user-menu">
              <span className="user-name">
                {user.first_name} {user.last_name}
                {isAdmin && <span className="admin-badge">Admin</span>}
              </span>
              <button onClick={handleLogout} className="logout-button">
                Sign Out
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default CognitoHeader;